export default __webpack_public_path__ + "static/media/proposal-icon-add.4e04cfb8.svg";